export default "__VITE_ASSET__Bbh9KN8x__"